<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.filter"
      @keydown.esc="dialog.filter = false"
      @keydown.enter="dialog.filter = false; dialog.fullscreen = false; fetch();"
      :fullscreen="dialog.fullscreen"
      width="550"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Filter Data

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.filter = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="py-0">
          <v-form>
            <div>
              <p class="body-2 mt-4 mb-2">
                Unit
              </p>

              <v-select
                filled
                rounded
                dense
                single-line
                hide-details
                :color="set_color"
                :item-color="set_color"
                placeholder="Contoh. Retail dan Kuliner"
                :items="unit"
                clearable
                @click:clear="filter.unit = ''"
                v-model="filter.unit"
                class="mb-4"
                style="width: 70%; border-radius: 10px !important;">
              </v-select>
            </div>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :color="set_color"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.filter = false; dialog.fullscreen = false; fetch();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Filter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.freeze"
      @keydown.esc="dialog.freeze = false"
      :fullscreen="dialog.fullscreen"
      width="400"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Freeze Kolom

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="py-0">
          <v-form>
            <v-row>
              <v-col>
                <div>
                  <p class="mb-2">
                    Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                  </p>

                  <v-list-item-group
                    multiple>
                    <v-list flat>
                      <v-list-item 
                        v-for="(item, index) in configHeaders" 
                        :key="index"
                        class="px-0"
                        @click="item.freeze = !item.freeze ? true : false">
                        <v-list-item-action class="mr-4">
                          <v-checkbox
                            :color="set_color"
                            :input-value="item.freeze">
                          </v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <p
                            class="mb-0"
                            :class="item.freeze ? 'font-weight-bold' : ''"
                            :style="item.freeze ? `color: ${set_color};` : ''">
                            {{ item.text }}
                          </p>
                        </v-list-item-content>
                      </v-list-item>  
                    </v-list>
                  </v-list-item-group>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :color="set_color"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Freeze
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.hide"
      @keydown.esc="dialog.hide = false"
      :fullscreen="dialog.fullscreen"
      width="400"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Hide Kolom

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.hide = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="py-0">
          <v-form>
            <v-row>
              <v-col>
                <div>
                  <p class="mb-2">
                    Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                  </p>

                  <v-list-item-group
                    multiple>
                    <v-list flat>
                      <v-list-item 
                        v-for="(item, index) in headers" 
                        :key="index"
                        class="px-0"
                        @click="item.hide = !item.hide ? true : false">
                        <v-list-item-action class="mr-4">
                          <v-checkbox
                            :color="set_color"
                            :input-value="item.hide">
                          </v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <p
                            class="mb-0"
                            :class="item.hide ? 'font-weight-bold' : ''"
                            :style="item.hide ? `color: ${set_color};` : ''">
                            {{ item.text }}
                          </p>
                        </v-list-item-content>
                      </v-list-item>  
                    </v-list>
                  </v-list-item-group>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :color="set_color"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Hide
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      width="625"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          {{ form.id === '' ? 'Tambah' : 'Setujui / Tolak' }}

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <ValidationObserver 
            ref="form">
            <v-form v-if="form.id === ''">
              <ValidationProvider 
                name="user_id" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Pegawai
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-autocomplete
                  v-on:keyup.enter="save"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  placeholder="Contoh. John Doe"

                  :search-input.sync="autocomplete.user"
                  :loading="process.user"
                  
                  :items="user"
                  item-value="id"
                  item-text="name"
                  :item-color="set_color"

                  v-model="form.user_id"
                  :success="form.user_id !== '' && valid"
                  :error-messages="errors"
                  required
                  class="mb-6"
                  style="border-radius: 10px; width: 60%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Pegawai {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.user_id !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-autocomplete>
              </ValidationProvider>

              <ValidationProvider 
                name="value" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Jumlah Lembur
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"
                  
                  placeholder="Contoh. 2 Jam"

                  v-model="form.value"
                  :success="form.value !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 40%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Jumlah Lembur {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.value !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <div>
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Tanggal Lembur
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-menu
                  ref="date"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="picker.date">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="date" 
                      rules="required"
                      v-slot="{ errors, valid }">
                      <v-text-field
                        v-on:keyup.enter="save"
                        readonly
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="Contoh. 2023-12-30"
                        hide-details
                        clearable

                        @click:clear="form.date = ''"
                        v-on="on"
                        v-bind="attrs"

                        v-model="form.date"
                        :success="form.date !== '' && valid"
                        :error-messages="errors"
                        class="mb-6"
                        style="border-radius: 10px; width: 50%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Tanggal Lembur {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.date !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-date-picker 
                    :color="set_color"
                    v-model="form.date"
                    @input="picker.date = false">
                  </v-date-picker>
                </v-menu>
              </div>

              <ValidationProvider 
                name="note" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                 <span class="red--text">*</span>
                  Keterangan
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-textarea
                  filled
                  rounded
                  dense
                  rows="3"
                  hide-details
                  :color="set_color"
                  placeholder="Contoh. Tambahan lemburan"

                  v-model="form.note"
                  :success="form.note !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Keterangan {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.note !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-textarea>
              </ValidationProvider>

              <ValidationProvider 
                name="day_type" 
                rules="required"
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Tipe Hari
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-select
                  v-on:keyup.enter="save()"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. Hari Kerja"
                  hide-details
                  
                  :items="[
                    {
                      text: 'Hari Kerja',
                      value: 'hari kerja'
                    },
                    {
                      text: 'Hari Libur',
                      value: 'hari libur'
                    }
                  ]"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-model="form.day_type"
                  :success="form.day_type !== '' && valid"
                  :error-messages="errors"
                  class="mb-2"
                  style="max-width: 50%; border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Tipe Hari {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.day_type !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-form>

            <v-form v-else>
              <ValidationProvider 
                name="approve_reject_id" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Pegawai Menyetujui / Menolak
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-autocomplete
                  v-on:keyup.enter="save"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  placeholder="Contoh. John Doe"

                  :search-input.sync="autocomplete.user"
                  :loading="process.user"
                  
                  :items="user"
                  item-value="id"
                  item-text="name"
                  :item-color="set_color"

                  v-model="form.approve_reject_id"
                  :success="form.approve_reject_id !== '' && valid"
                  :error-messages="errors"
                  required
                  class="mb-6"
                  style="border-radius: 10px; width: 60%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Pegawai Menyetujui / Menolak {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.approve_reject_id !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-autocomplete>
              </ValidationProvider>

              <ValidationProvider 
                name="status" 
                rules="required"
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Status
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-select
                  v-on:keyup.enter="save()"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. Setujui"
                  hide-details
                  
                  :items="[
                    {
                      text: 'Setujui',
                      value: 'approved'
                    },
                    {
                      text: 'Tolak',
                      value: 'rejected'
                    }
                  ]"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-model="form.status"
                  :success="form.status !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="max-width: 50%; border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Status {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.status !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-form>
          </ValidationObserver>

          <v-alert 
            type="error" 
            text dense prominent 
            class="mt-6"
            v-show="message.error.length > 0">
            {{ message.error }}
          </v-alert>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.form = false; reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col 
        cols="12"
        class="py-0">
        <v-card 
          flat 
          style="border: 1px solid #E0E0E0;">
          <v-card-text>
            <v-row>
              <v-col 
                cols="12" 
                md="8" 
                class="d-flex align-center">
                <div class="mr-3">
                  <v-btn
                    elevation="0"
                    dark
                    style="border-radius: 10px;"
                    :color="set_color"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center"
                    @click="dialog.filter = true; fetchUnit();">
                    <v-icon size="18">mdi-filter-outline</v-icon>

                    <span class="ml-1">
                      Filter
                    </span>
                  </v-btn>
                </div>

                <div class="mr-3">
                  <v-btn
                    elevation="0"
                    style="background: #4caf5033; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center green--text"
                    @click="dialog.form = true; reset();">
                    <v-icon size="18">mdi-plus-circle-outline</v-icon>

                    <span class="ml-1">
                      Tambah
                    </span>
                  </v-btn>
                </div>

                <div v-if="selected.row.length === 1 && selected.row[0].submission_by === 'user'">
                  <v-btn
                    elevation="0"
                    style="background: #00bcd433; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center cyan--text"
                    @click="dialog.form = true; reset(selected.row[0]);">
                    <v-icon size="18">mdi-reload-alert</v-icon>

                    <span class="ml-1">
                      Setujui / Tolak
                    </span>
                  </v-btn>
                </div>
              </v-col>
                
              <v-col 
                cols="12" 
                md="4" 
                class="d-flex align-center justify-end">
                <v-text-field
                  filled
                  rounded
                  dense
                  single-line
                  hide-details
                  :color="set_color"
                  placeholder="Cari . . ."
                  vvvv-uppercase
                  append-icon="mdi-magnify"
                  clearable
                  v-model="search"
                  @click:clear="search = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  style="border-radius: 10px;">
                </v-text-field>

                <!-- FREEZE COLUMN -->
                <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        :color="set_color"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.freeze = true">
                        <v-icon size="18">mdi-table-split-cell</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Freeze
                    </span>
                  </v-tooltip>
                </div>

                <!-- HIDE COLUMN -->
                <div class="ml-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="0"
                        outlined
                        dark
                        min-width="36"
                        color="#7B7B7B"
                        class="text-capitalize px-0"
                        style="border-radius: 10px;"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog.hide = true">
                        <v-icon size="18">mdi-eye-off-outline</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Hide
                    </span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-data-table
            v-model="selected.row"
            ref="table-grid"
            class="table-grid"
            :height="`calc(100vh - ${pagination.total_data > 0 ? '274px' : '202px'})`"
            :show-select="checkbox"
            :single-select="true"
            :loading="process.load"
            loading-text="Sedang memuat data . . ."
            loader-height="5"
            no-results-text="Belum ada data"
            :options.sync="options"
            :headers="configHeaders"
            :items="list"
            :items-per-page="100"
            item-key="id"
            @click:row="rowClick"
            @toggle-select-all="handleToggleAll($event)"
            @dblclick:row="doubleClick"
            hide-default-footer>
            <template
              v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
              v-slot:[`item.${header.value}`]="{ value }">
              {{ rowFormat(header.format, value) }} 
            </template>

            <template v-slot:[`item.index`]="{ index }">
              {{ lastIndex + index }}
            </template>

            <v-progress-linear 
              v-show="process.load" 
              slot="progress" 
              color="white" 
              indeterminate>
            </v-progress-linear>
          </v-data-table>

          <pagination v-if="pagination.total_data > 0"
            @changePage="fetch($event)" 
            @reloadPage="fetch($event)" 
            :model="pagination"/>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,
          form: false,
          filter: false
        },
        search: '',
        filter: {
          unit: ''
        },
        selected: {
          row: [],
          freeze: []
        },
        options: {},
        headers: [],
        list: [],
        user: [],
        unit: [],
        pagination: {},
        lastIndex: 0,
        limit: 20,
        autocomplete: {
          user: ''
        },
        picker: {
          date: false
        },
        form: {
          id: '',
          user_id: '',
          value: '',
          date: '',
          note: '',
          day_type: '',

          // APPROVED / REJECTED
          approve_reject_id: '',
          status: ''
        },
        process: {
          load: false,
          form: false,
          user: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },
      set_color () {
        return this.$store.state.color
      }
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      },
      'autocomplete.user': function() {
        this.fetchUser()
      }
    },
    mounted () {
      // this.fetch()
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value.split('.')[0]
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          },00`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].title)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          // data = value.length > 0 ? moment(value).format(format === 'date' ? 'D MMM, YYYY' : format === 'time' ? 'HH:mm' : 'D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }
        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,
          status: 'submission',
          unit_id: this.filter.unit
        }

        this.selected.row = []

        await get('admin/overtime', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.headers = [
              {
                text: '#No',
                width: '75px',
                value: 'index',
                sortable: false,
                freeze: true,
                hide: false,
                align: 'center'
              },
              {
                text: 'Status',
                width: '200px',
                value: 'status',
                freeze: false,
                hide: false
              },
              {
                text: 'Nomor Induk Pegawai',
                width: '200px',
                value: 'user_code',
                freeze: false,
                hide: false
              },
              {
                text: 'Nama Lengkap',
                width: '400px',
                value: 'user_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Jumlah Lembur (Jam)',
                width: '200px',
                value: 'value',
                freeze: false,
                hide: false
              },
              {
                text: 'Tipe Hari',
                width: '200px',
                value: 'day_type',
                freeze: false,
                hide: false
              },
              {
                text: 'Tanggal Lembur',
                width: '200px',
                value: 'date',
                freeze: false,
                hide: false,
                format: 'date'
              },
              {
                text: 'Keterangan',
                width: '400px',
                value: 'desc',
                freeze: false,
                hide: false
              },
              {
                text: 'Pengajuan (Dari)',
                width: '200px',
                value: 'submission_by',
                freeze: false,
                hide: false
              },
              {
                text: 'Disetujui / Ditolak Oleh',
                width: '200px',
                value: 'approve_reject_by',
                freeze: false,
                hide: false
              }
            ]
            
            this.list = res.results.data
            this.pagination = res.results.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },
      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: ${this.set_color};
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: ${this.set_color};
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      async fetchUser () {
        this.process.user = true

        let params = {
          search: this.autocomplete.user
        }

        await get('admin/user', { params })
        .then(response => {
          let res = response.data

          this.process.user = false
            
          if (res.status === 200) {
            this.user = res.results.data
          }
        })
      },
      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: item !== undefined ? item.id : '',
          user_id: '',
          value: '',
          date: '',
          note: '',
          day_type: '',

          // APPROVED / REJECTED
          approve_reject_id: '',
          status: ''
        }

        this.picker = {
          date: false
        }

        this.process.form = false

        this.message.error = ''
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id.length < 1 ? 'admin/overtime/submission' : 'admin/overtime/approval'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },


      // UNIT
      async fetchUnit () {
        let params = {
          limit: 100000
        }

        this.unit = []

        await get('admin/unit', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data.map(obj => {
              this.unit.push({
                text: obj.name,
                value: obj.id
              })
            })
          }
        })
      }
    }
  }
</script>

<style>
  .table-grid table thead > tr > th, .table-grid table tbody > tr > td {
    position: sticky;
    position: -webkit-sticky;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }

  .table-grid table > tbody > tr > td:nth-child(1) {
    left: 0; 
    z-index: 1;
  }

  .table-grid table > tbody > tr:nth-of-type(even) .text-start, table > tbody > tr:nth-of-type(even) .text-center, table > tbody > tr:nth-of-type(even) .text-end {
    background: #fafafa;
  }

  .table-grid table > tbody > tr:nth-of-type(odd) .text-start, table > tbody > tr:nth-of-type(odd) .text-center, table > tbody > tr:nth-of-type(odd) .text-end {
    background: white;
  }
</style>